import { render, staticRenderFns } from "./day-span.vue?vue&type=template&id=0a8284fd&scoped=true"
import script from "./day-span.vue?vue&type=script&lang=js"
export * from "./day-span.vue?vue&type=script&lang=js"
import style0 from "./day-span.vue?vue&type=style&index=0&id=0a8284fd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a8284fd",
  null
  
)

export default component.exports